(()=> {
    class TutorialsSelect extends HTMLElement {
        constructor() {
            super();
            this.tabs = [];
            this.cards = [];
            this.activeTab = null;
        }

        connectedCallback() {
            const urlParams = new URLSearchParams(window.location.search);
            const paramTab = urlParams.get("tab");

            const selectedTabEl = this.querySelector(".Toggle__tab[data-selected]");
            this.activeTab = paramTab || (selectedTabEl ? selectedTabEl.dataset.selected : null);

            this.tabs = Array.from(this.querySelectorAll(".Toggle__tab"));
            this.cards = Array.from(this.querySelectorAll(".Loop--tutorials"));

            this.bindEvents();
            this.activateTab(this.activeTab);

            window.addEventListener("popstate", (event) => {
                const tabId =
                    (event.state && event.state.tabId) ||
                    new URL(window.location.href).searchParams.get("tab") ||
                    (this.querySelector(".Toggle__tab[data-selected]")?.dataset.selected || null);
                this.activateTab(tabId, false);
            });
        }

        bindEvents() {
            this.tabs.forEach((tab) => {
                tab.addEventListener("click", () => {
                    const selectedCategory = tab.dataset.category;
                    this.activateTab(selectedCategory, true);
                });
            });
        }

        activateTab(tabId, updateUrl = false) {
            if (!tabId) return;

            this.tabs.forEach((t) => t.classList.toggle("is-selected", t.dataset.category === tabId));

            this.cards.forEach((card) => {
                const isMatch = card.dataset.category === tabId;
                card.style.display = isMatch ? "block" : "none";
                card.classList.toggle("is-selected", isMatch);
            });

            if (updateUrl) {
                const newUrl = new URL(window.location.href);
                newUrl.searchParams.set("tab", tabId);
                history.pushState({ tabId }, "", newUrl.toString());
            }

            this.activeTab = tabId;
        }
    }

    customElements.define('tutorials-select', TutorialsSelect);
})()